// src/pages/About/ParceirosPage.jsx

import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Paper,
  Chip,
  IconButton,
  TextField,
  MenuItem,
  Divider,
  Rating,
} from '@mui/material';
import {
  School as SchoolIcon,
  LocationOn as LocationIcon,
  Language as LanguageIcon,
  CheckCircle as CheckCircleIcon,
  Email as EmailIcon,
  ArrowForward as ArrowForwardIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Star as StarIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';

const ParceirosPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterRegion, setFilterRegion] = useState('all');
  const [filterType, setFilterType] = useState('all');

  // Dados das instituições parceiras
  const partners = [
    {
      id: 1,
      name: 'Instituto Superior de Gestão e Empreendedorismo Gwaza Muthini',
      type: 'Instituicão Privada',
      location: 'Maputo',
      logo: '/path/to/logo1.png',
      description: 'Uma das renomadas instituição de ensino superior de Moçambique.',
      rating: 4.8,
      students: 4500,
      courses: 12,
      website: 'https://isgegm.ac.mz',
      verified: true,
      campaigns: 2,
    },
 
   
  ];

  // Filtros disponíveis
  const regions = [
    { value: 'all', label: 'Todas as Regiões' },
    { value: 'maputo', label: 'Sul' },
    { value: 'beira', label: 'Centro' },
    { value: 'nampula', label: 'Norte' },
  ];

  const types = [
    { value: 'all', label: 'Todos os Tipos' },
    { value: 'universidade', label: 'Universidade' },
    { value: 'instituto', label: 'Instituto Superior' },
    { value: 'escola', label: 'Escola Técnica' },
    { value: 'colegios', label: 'Colegios' },
  ];

  // Filtragem dos parceiros
  const filteredPartners = partners.filter(partner => {
    const matchesSearch = partner.name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesRegion = filterRegion === 'all' || partner.location.toLowerCase() === filterRegion;
    const matchesType = filterType === 'all' || partner.type.toLowerCase().includes(filterType);
    return matchesSearch && matchesRegion && matchesType;
  });

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          py: 8,
          mb: -4,
          position: 'relative',
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h3" component="h1" gutterBottom>
            Instituições Parceiras
          </Typography>
          <Typography variant="h6" paragraph>
            Conheça as instituições que fazem parte do ZenKroll
          </Typography>
          <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<SchoolIcon />}
              component={Link}
              to="/registro/instituicao"
            >
              Tornar-se Parceiro
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              startIcon={<EmailIcon />}
              href="mailto:parcerias@zenkroll.co.mz"
            >
              Contacto Comercial
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Filtros e Pesquisa */}
      <Container maxWidth="lg" sx={{ mt: 8, mb: 4 }}>
        <Paper sx={{ p: 3, mb: 4 }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                placeholder="Pesquisar instituição..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                value={filterRegion}
                onChange={(e) => setFilterRegion(e.target.value)}
                label="Região"
              >
                {regions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                value={filterType}
                onChange={(e) => setFilterType(e.value)}
                label="Tipo de Instituição"
              >
                {types.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => {
                  setFilterRegion('all');
                  setFilterType('all');
                  setSearchQuery('');
                }}
              >
                Limpar Filtros
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {/* Lista de Parceiros */}
        <Grid container spacing={4}>
          {filteredPartners.map((partner) => (
            <Grid item xs={12} key={partner.id}>
              <Card sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
                <CardMedia
                  component="img"
                  sx={{ width: { xs: '100%', md: 200 }, objectFit: 'contain', p: 2 }}
                  image={partner.logo}
                  alt={partner.name}
                />
                <CardContent sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <Typography variant="h5" component="h2">
                      {partner.name}
                    </Typography>
                    {partner.verified && (
                      <CheckCircleIcon color="primary" />
                    )}
                  </Box>

                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <Chip
                      icon={<SchoolIcon />}
                      label={partner.type}
                      size="small"
                    />
                    <Chip
                      icon={<LocationIcon />}
                      label={partner.location}
                      size="small"
                    />
                  </Box>

                  <Typography variant="body2" color="text.secondary" paragraph>
                    {partner.description}
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Avaliação
                      </Typography>
                      <Rating value={partner.rating} readOnly size="small" />
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Estudantes
                      </Typography>
                      <Typography variant="body2">
                        {partner.students.toLocaleString()}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Cursos
                      </Typography>
                      <Typography variant="body2">
                        {partner.courses}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Campanhas Activas
                      </Typography>
                      <Typography variant="body2">
                        {partner.campaigns}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                      variant="contained"
                      endIcon={<ArrowForwardIcon />}
                      component={Link}
                      to={`/instituicoes/${partner.id}`}
                    >
                      Ver Campanhas
                    </Button>
                    <IconButton
                      color="primary"
                      href={partner.website}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LanguageIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Seção "Torne-se um Parceiro" */}
        <Paper sx={{ p: 4, mt: 6, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Torne-se um Parceiro
          </Typography>
          <Typography variant="body1" paragraph>
            Junte-se à maior plataforma de pré-inscrições de Moçambique e alcance mais estudantes.
          </Typography>
          <Grid container spacing={4} justifyContent="center" sx={{ mt: 2 }}>
            <Grid item xs={12} md={4}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <SchoolIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Maior Visibilidade
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Alcance milhares de estudantes em potencial.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <StarIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Gestão Simplificada
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Ferramentas completas para gestão de pré-inscrições.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <CheckCircleIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Suporte Dedicado
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Equipe especializada para auxiliar sua instituição.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Button
            variant="contained"
            size="large"
            sx={{ mt: 4 }}
            component={Link}
            to="/contato/comercial"
          >
            Fale com Nossa Equipe Comercial
          </Button>
        </Paper>
      </Container>

      <Footer />
    </Box>
  );
};

export default ParceirosPage;